import { PropsWithChildren } from 'react';
import { extendTheme, useToken } from '@chakra-ui/react';
import { orangeTheme } from '../THD/colors';
import { ChakraDefaultProvider } from 'Shared/chakra-provider';

type DiagramTheme = {
   clusterOuter: string;
   clusterInner: string;
   hotspotInner: string;
   hotspotOuter: string;
};

const useTheme = (name: string): DiagramTheme => {
   const [blue400, blue100] = useToken('colors', ['brand.400', 'brand.100']);
   const blueTheme: DiagramTheme = {
      clusterOuter: blue400,
      clusterInner: blue100,
      hotspotInner: blue400,
      hotspotOuter: blue100,
   };

   switch (name) {
      case 'orange': {
         return orangeTheme;
      }
      case 'blue': {
         return blueTheme;
      }
      default: {
         return blueTheme;
      }
   }
};

export type RequiredThemeProps = {
   theme: 'blue' | 'orange';
};

function toChakraTheme(diagramTheme: DiagramTheme) {
   return {
      colors: diagramTheme,
   };
}

export function SchematicThemeProvider({
   theme: themeName,
   children,
}: PropsWithChildren<RequiredThemeProps>) {
   const diagramTheme = useTheme(themeName);
   const schematicsTheme = extendTheme(toChakraTheme(diagramTheme));
   return <ChakraDefaultProvider theme={schematicsTheme}>{children}</ChakraDefaultProvider>;
}
